import { HeaderContactOptions } from "@kunduz/ui-components";
import {
  WebsiteTrFooter,
  WebsiteEnFooter,
  DynamicHeader,
  HeaderBannerWithContext,
} from "../components";
import { type IContent } from "@kunduz/data-access-cms-api";
import { NextSeo } from "next-seo";
import Head from "next/head";
import { ComponentRenderer } from "../components/componentRenderer/componentRenderer";
import { Render } from "@measured/puck";
import { puckConfig } from "@kunduz/feature-puck-editor";

export function CmsBackedLandingPage({
  meta,
  lang,
  by,
  contentType,
}: {
  meta: IContent.IContentTypeResponse;
  lang: "tr" | "en";
  by?: "cms" | "puck";
  contentType: IContent.ContentType & IContent.ContentTypeContent;
}) {
  const headerBannerData = meta?.components?.find(
    (component) => component.component_type === "header-banner",
  );

  if (by === "puck" && contentType) {
    return <Render config={puckConfig} data={contentType?.content} />;
  }

  return (
    <>
      <Head>
        <link rel="preconnect" href="https://media.kunduz.com" />
      </Head>
      <NextSeo
        title={meta?.seo_title}
        description={meta?.seo_desc}
        canonical={meta?.canonical_url}
        noindex={meta?.no_index}
        openGraph={{
          images: [{ url: meta?.seo_icon as string }],
        }}
      />

      {headerBannerData && (
        <HeaderBannerWithContext
          name={headerBannerData.name}
          buttonLabel={
            (headerBannerData.data as IContent.HeaderBannerComponentData[])[0]
              .cta_title
          }
          label={
            (headerBannerData.data as IContent.HeaderBannerComponentData[])[0]
              .content
          }
          url={
            (headerBannerData.data as IContent.HeaderBannerComponentData[])[0]
              .cta_link
          }
        />
      )}

      {lang == "tr" && (
        <HeaderContactOptions
          secondLabel="0850 532 16 29"
          secondUrl="tel:08505321629"
          thirdLabel="Sıkça Sorulan Sorular"
          thirdUrl="/tr/sss/"
          forthLabel="destek@kunduz.com"
          forthUrl="mailto:destek@kunduz.com"
        />
      )}
      {lang == "en" && (
        <HeaderContactOptions
          thirdLabel="Frequently Asked Questions"
          thirdUrl="/faq/"
          forthLabel="school@kunduz.com"
          forthUrl="mailto:school@kunduz.com"
        />
      )}

      <DynamicHeader
        headerItems={meta.header_items}
        headerType={meta.landing_page_header}
        lang={lang}
      />

      <ComponentRenderer components={meta.components} lang={lang} />

      {lang == "tr" && <WebsiteTrFooter />}
      {lang == "en" && <WebsiteEnFooter />}
    </>
  );
}
